(function () {
  'use strict';
  function initialize() {
    var setup = document.querySelector('[data-campaign-signup-brand]');
    var brand = setup && setup.getAttribute('data-campaign-signup-brand');
    if (brand !== 'gaspard-cottance' && brand !== 'spooge') return;
    var modal = document.getElementById('b2bOnboardingModal');
    var content = document.getElementById('b2bModalContent');
    var close = document.getElementById('b2bCloseModal');
    if (!modal || !content || !close || modal.dataset.campaignModalReady) return;
    modal.dataset.campaignModalReady = 'true';
    modal.classList.add('campaign-signup-dialog');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Welcome to Beauty Rep');
    modal.setAttribute('tabindex', '-1');
    close.setAttribute('type', 'button');
    close.setAttribute('aria-label', brand === 'gaspard-cottance' ? 'Close invitation' : 'Close signup');
    close.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>';

    var active = false;
    var opener = null;
    var saved = null;
    var background = [];
    function isOpen() { return !modal.classList.contains('invisible') && !modal.classList.contains('opacity-0'); }
    function visible(element) {
      if (element.disabled || element.getAttribute('type') === 'hidden' || element.tabIndex < 0) return false;
      for (var node = element; node && node !== modal.parentElement; node = node.parentElement) {
        var style = window.getComputedStyle(node);
        if (node.hidden || node.inert || style.display === 'none' || style.visibility === 'hidden') return false;
      }
      return true;
    }
    function focusables() {
      return Array.from(modal.querySelectorAll('a[href],button,input,select,textarea,[tabindex]')).filter(visible);
    }
    function focusContent() {
      if (!active) return;
      var email = document.getElementById('providerVerifyEmail');
      var target = email && visible(email) ? email : (focusables()[0] || modal);
      target.focus({ preventScroll: true });
    }
    function open() {
      if (active) return;
      active = true;
      opener = document.activeElement;
      saved = {
        x: window.scrollX, y: window.scrollY,
        position: document.body.style.position, top: document.body.style.top,
        left: document.body.style.left, right: document.body.style.right,
        width: document.body.style.width, overflow: document.body.style.overflow,
        rootOverflow: document.documentElement.style.overflow
      };
      document.body.style.position = 'fixed';
      document.body.style.top = -saved.y + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      background = [];
      for (var branch = modal; branch.parentElement; branch = branch.parentElement) {
        Array.from(branch.parentElement.children).forEach(function (sibling) {
          if (sibling === branch || /^(SCRIPT|STYLE|LINK)$/.test(sibling.tagName)) return;
          background.push([sibling, sibling.inert]);
          sibling.inert = true;
        });
        if (branch.parentElement === document.body) break;
      }
      modal.setAttribute('aria-hidden', 'false');
      content.scrollTop = 0;
      setTimeout(focusContent, 0);
    }
    function restore() {
      if (!active) return;
      active = false;
      background.forEach(function (entry) { entry[0].inert = entry[1]; });
      background = [];
      ['position', 'top', 'left', 'right', 'width', 'overflow'].forEach(function (key) { document.body.style[key] = saved[key]; });
      document.documentElement.style.overflow = saved.rootOverflow;
      var previousScrollBehavior = document.documentElement.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = 'auto';
      window.scrollTo(saved.x, saved.y);
      document.documentElement.style.scrollBehavior = previousScrollBehavior;
      modal.setAttribute('aria-hidden', 'true');
      if (opener && opener.isConnected && typeof opener.focus === 'function') opener.focus({ preventScroll: true });
    }
    document.addEventListener('keydown', function (event) {
      if (!active) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        close.click();
        return;
      }
      if (event.key !== 'Tab') return;
      var targets = focusables();
      if (!targets.length) { event.preventDefault(); modal.focus(); return; }
      var first = targets[0], last = targets[targets.length - 1];
      if (!modal.contains(document.activeElement) || (event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      }
    }, true);
    document.addEventListener('focusin', function (event) {
      if (active && !modal.contains(event.target)) focusContent();
    });
    new MutationObserver(function () { if (isOpen()) open(); else restore(); }).observe(modal, { attributes: true, attributeFilter: ['class'] });
    modal.setAttribute('aria-hidden', isOpen() ? 'false' : 'true');
    if (isOpen()) open();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
